module.exports = __webpack_public_path__ + "static/1191762016.adb72d0a.jpg";